/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../has.js";
var e;
!function (t) {
  t[t.HANDSHAKE = 0] = "HANDSHAKE", t[t.OPEN = 1] = "OPEN", t[t.OPENED = 2] = "OPENED", t[t.RESPONSE = 3] = "RESPONSE", t[t.INVOKE = 4] = "INVOKE", t[t.ABORT = 5] = "ABORT", t[t.CLOSE = 6] = "CLOSE", t[t.OPEN_PORT = 7] = "OPEN_PORT", t[t.ON = 8] = "ON";
}(e || (e = {}));
var r = 0;

function n() {
  return r++;
}

function s(t) {
  return t && "object" == typeof t && ("result" in t || "transferList" in t);
}

function a(t) {
  return t ? "string" == typeof t ? JSON.stringify({
    name: "message",
    message: t
  }) : t.toJSON ? JSON.stringify(t) : JSON.stringify({
    name: t.name,
    message: t.message,
    details: t.details || {
      stack: t.stack
    }
  }) : null;
}

function i(t, r, n, a) {
  if (r.type === e.OPEN_PORT) return void t.postMessage(r, [r.port]);
  if (r.type !== e.INVOKE && r.type !== e.RESPONSE) return void t.postMessage(r);
  var i;
  s(n) ? (i = o(n.transferList), r.data = n.result) : (i = o(a), r.data = n), i ? t.postMessage(r, i) : t.postMessage(r);
}

function f(t) {
  if (!t) return null;
  var e = t.data;
  return e ? "string" == typeof e ? JSON.parse(e) : e : null;
}

function o(e) {
  if (!e || !e.length) return null;
  if (t("esri-workers-arraybuffer-transfer")) return e;
  var r = e.filter(function (t) {
    return !u(t);
  });
  return r.length ? r : null;
}

function u(t) {
  return t instanceof ArrayBuffer || t && t.constructor && "ArrayBuffer" === t.constructor.name;
}

export { e as MessageType, s as isTranferableResult, n as newJobId, i as postMessage, f as receiveMessage, a as toInvokeError };